<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      opacity="0.3"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0356 10.6211L14.8636 7.79308C14.9558 7.69757 15.0662 7.62139 15.1882 7.56898C15.3102 7.51657 15.4414 7.48898 15.5742 7.48783C15.707 7.48668 15.8387 7.51198 15.9615 7.56226C16.0844 7.61254 16.1961 7.68679 16.29 7.78069C16.3839 7.87458 16.4581 7.98623 16.5084 8.10913C16.5587 8.23202 16.584 8.3637 16.5828 8.49648C16.5817 8.62926 16.5541 8.76048 16.5017 8.88249C16.4493 9.00449 16.3731 9.11483 16.2776 9.20708L13.4496 12.0361L16.2776 14.8641C16.3731 14.9563 16.4493 15.0667 16.5017 15.1887C16.5541 15.3107 16.5817 15.4419 16.5828 15.5747C16.584 15.7075 16.5587 15.8391 16.5084 15.962C16.4581 16.0849 16.3839 16.1966 16.29 16.2905C16.1961 16.3844 16.0844 16.4586 15.9615 16.5089C15.8387 16.5592 15.707 16.5845 15.5742 16.5833C15.4414 16.5822 15.3102 16.5546 15.1882 16.5022C15.0662 16.4498 14.9558 16.3736 14.8636 16.2781L12.0356 13.4501L9.20659 16.2781C9.11435 16.3736 9.004 16.4498 8.882 16.5022C8.75999 16.5546 8.62877 16.5822 8.49599 16.5833C8.36321 16.5845 8.23154 16.5592 8.10864 16.5089C7.98574 16.4586 7.87409 16.3844 7.7802 16.2905C7.68631 16.1966 7.61205 16.0849 7.56177 15.962C7.51149 15.8391 7.48619 15.7075 7.48734 15.5747C7.4885 15.4419 7.51608 15.3107 7.56849 15.1887C7.6209 15.0667 7.69708 14.9563 7.79259 14.8641L10.6206 12.0361L7.79259 9.20708C7.61044 9.01848 7.50964 8.76588 7.51192 8.50368C7.5142 8.24148 7.61937 7.99067 7.80477 7.80526C7.99018 7.61985 8.241 7.51469 8.50319 7.51241C8.76539 7.51013 9.01799 7.61092 9.20659 7.79308L12.0356 10.6211Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
import { type CbIconProps, cbIconDefaults } from "../cb-icon.props";

withDefaults(defineProps<CbIconProps>(), cbIconDefaults);
</script>
